const makeInitialState = (contract, balance) => {
  return {
    contractId: contract.id,
    balance,
    clientName: contract.clientName,
    clientId: contract.clientId,
    equipmentId: contract.equipmentId,
    equipmentBrand: contract.equipmentData.brand,
    equipmentModel: contract.equipmentData.model,
    cedeDate: null,
    createdAt: null,
    startDate: null,
    endDate: contract.endDate,
    rent: contract.rent,
    forgiveDebt: false,
    folio: contract.folioWithoutPrefix
  };
};

export default makeInitialState;
